import React, { useState, useEffect } from 'react';
import mailMessageApi from '../../../services/apiServices/mailMessageApi';
import { setLoading } from '../../../services/redux/loadingSlice';
import { useDispatch } from 'react-redux';
import configService from '../../../services/configService';
import Pagination from '../../../components/common/Pagination/Pagination';
import { toast } from 'react-toastify';
import { putDateOnPattern } from '../../../utils/functions';
import FilterComponent from '../../../components/admin/FilterComponent/FilterComponent';
import { saveAs } from 'file-saver';
import DownloadIcon from '../../../components/icons/DownloadIcon';
import { useSearchParams } from 'react-router-dom';

const MailMessageListPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState(searchParams.get('term') || '');
    const [status, setStatus] = useState(searchParams.get('status') || '');
    const [startDate, setStartDate] = useState(searchParams.get('startDate') || '');
    const [endDate, setEndDate] = useState(searchParams.get('endDate') || '');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItens, setTotalItens] = useState(0);
    const [refresh, setRefresh] = useState(false);
    const quantity = configService.getDefaultNumberOfItemsTable();
    const [showFilters, setShowFilters] = useState(searchParams.toString().length > 0);
    const toggleFilters = () => setShowFilters(prev => !prev);
    const orderBy = "Created:Desc";
    const statusOptions = [
        { value: 'Sent', label: 'Enviado' },
        { value: 'NotSent', label: 'Não enviado' }
    ];

    useEffect(() => {
        const fetchMailMessages = async () => {
            dispatch(setLoading(true));
            try {
                const response = await mailMessageApi.getMailMessagesPaginated({
                    page,
                    quantity,
                    orderBy,
                    term: searchTerm || undefined,
                    startDate: startDate || undefined,
                    endDate: endDate || undefined,
                    mailMessageStatus: status || undefined
                });
                setItems(response.Results || []);
                setTotalPages(response.TotalPages || 1);
                setTotalItens(response.TotalCount || 0);
            } catch (error) {
                toast.error('Erro ao buscar os itens.');
            } finally {
                dispatch(setLoading(false));
            }
        };
        fetchMailMessages();
    }, [page, quantity, searchTerm, status, startDate, endDate, refresh, dispatch]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const search = ({term, status, startDate, endDate} = {}) => {
        setSearchTerm(term || '');
        setStatus(status || '');
        setStartDate(startDate || '');
        setEndDate(endDate || '');
        setPage(1);

        const nextParams = new URLSearchParams();
        if (term) nextParams.set('term', term);
        if (status) nextParams.set('status', status);
        if (startDate) nextParams.set('startDate', startDate);
        if (endDate) nextParams.set('endDate', endDate);
        setSearchParams(nextParams);
    }

    const reenviar = async (id) => {
        try{
            dispatch(setLoading(true));
            var result = await mailMessageApi.resendMailMessageByCode(id);
            if(result.MailMessageStatus && result.MailMessageStatus === 'Sent'){
                toast.success('Email reenviado!')
                setRefresh(true);
            }
            else{
                toast.error('Erro ao reenviar!');
            }
        }
        catch{
            toast.error('Erro ao reenviar!');
        }
        finally{
            dispatch(setLoading(false));
        }
    }

    const exportFunction = async (term) => {
        try {
            dispatch(setLoading(true));
            const response = await mailMessageApi.exportMailMessages({
                term: term,
                startDate,
                endDate,
                mailMessageStatus: status || undefined
            });

            if (response.Status === 200 && response.Object) {
                window.open(response.Object, "_blank");
                toast.success('Relatório gerado com sucesso!');
            } else {
                toast.error('Erro ao gerar o relatório');
            }
        } catch (error) {
            toast.error('Erro ao gerar o relatório');
        }
        finally{
            dispatch(setLoading(false));
        }
    };

    const downloadItem = (mail) => {
        const blob = new Blob([mail.Body], { type: 'text/html;charset=utf-8' });
        saveAs(blob, `${mail.Subject.replace(/ /g, '_')}.html`);
    };

    return (
    <div className="container-admin-page">
        <div className='title-with-options'>
            <h1>Lista dos E-mails</h1>

            <button className="main-button" onClick={toggleFilters}>
                {showFilters ? 'Ocultar Filtros' : 'Mostrar Filtros'}
            </button>
        </div>

        {showFilters && (
            <div className='container-admin-page-filters div-with-border'>
                <h3>Filtros</h3>
                <FilterComponent
                    placeHolder={'Email | Assunto'}
                    showTermFilter={true}
                    showStartDate={true}
                    showEndDate={true}
                    initialTerm={searchTerm}
                    initialStartDate={startDate}
                    initialEndDate={endDate}
                    initialStatus={status}
                    statusOptions={statusOptions}
                    submitFilter={search}
                    exportFunction={exportFunction}
                />
            </div>
        )}

        <div className='container-admin-page-table div-with-border'>
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Enviado</th>
                        <th>Assunto</th>
                        <th>To</th>
                        <th>Status</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                {items.map((item) => (
                    <tr key={item.Id}>
                        <td data-label='Id'><span>{item.Id}</span></td>
                        <td data-label='Enviado'><span>{putDateOnPattern(item.Created)}</span></td>
                        <td data-label='Assunto'><span>{item.Subject}</span></td>
                        <td data-label='To'><span>{item.To}</span></td>
                        <td data-label='Status'><span>{item.MailMessageStatus === 'Sent' ? 'Enviado' : 'Não enviado'}</span></td>
                        <td><button className='main-button' disabled={item.MailMessageStatus === 'Sent'} onClick={() => {if(item.MailMessageStatus !== 'Sent') reenviar(item.Id)}}>Reenviar</button></td>
                        <td><span className='option-link' onClick={() => downloadItem(item)}><DownloadIcon/></span></td>
                    </tr>
                ))}
                {items.length === 0 && (
                    <tr>
                        <td colSpan="7">Nenhum e-mail encontrado para os filtros selecionados.</td>
                    </tr>
                )}
                </tbody>
            </table>
            <sub>Total de E-mails: {totalItens}</sub>
            <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    </div>
    );
};

export default MailMessageListPage;
